import React from 'react'
import { Button, Dropdown, Menu } from 'antd'
import { DataTable } from './DataTable'
import { YhBox } from '@/components/YhBox'
import { DescriptionColorEnum, IDescription } from '@/components/YhBox/Types'
import useNavModel from '@/model/navModel'
import { globalPrompt } from '@/components/message'
import { YhAuth } from '@/components/auth/YhAuth'
import { useApplyListDetailsModel } from './details/applyListDetailsModel'
import { useApplyListModel } from '../applyListModel'
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import { PlusOutlined } from '@ant-design/icons'

export const DataBox = () => {
    const { selectedRowKeys} = useApplyListModel()
    const { resetEditCatch,onApply } = useApplyListDetailsModel()
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => [])
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt('message', { text: '请选择单条数据进行编辑，点击鼠标右键可一键选中哦！', type: 'warning' })
            return
        }
        let ApplyListEditKey = '5-1-2'
        let isFindNav = findNav(ApplyListEditKey)
        if (!isFindNav) {
            addNav(ApplyListEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
            resetEditCatch()
        } else {
            globalPrompt('modal', {
                title: '物资领取跳转详情',
                type: 'warning',
                text: '您还有物资领取详情未保存，是否跳转',
                okText: '跳转未保存页',
                onOk: () => selectNav(isFindNav ? isFindNav.id : ''),
                cancelText: '打开新页签',
                onCancel: () => {
                    switchNavState(ApplyListEditKey, { id: selectedRowKeys[0] as string, mode: 'edit' })
                    resetEditCatch()
                },
            })
        }
    }

    const action = (
        <>
        <YhAuth resCode={ResourceAuthEnum.ASSETS_AP_L_AD}>
            <Button className="mr-5" type="link" shape="round" onClick={() => addNav('5-1-1', { id: '', mode: 'add' })}>
            <PlusOutlined />
                申请
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_AP_L_ED}>
            <Button className="mr-5" type="link" shape="round" onClick={onEdit}>
                编辑
            </Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_AP_L_EXAMINE}>
            <Button className="mr-5" type="link" shape="round" onClick={onApply}>
                审批
            </Button>
            </YhAuth>
        </>
    )

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}
